import React, { useEffect, useState } from "react";
import { postProcesarDeudores } from "services/ClientesServices";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Spinner,
} from "reactstrap";

const ModalProcesarDeudoresCSV = ({ isOpen, toggle }) => {
  const [archivo, setArchivo] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const maxSize = 450 * 1024; // 300 KB

    if (file.size > maxSize) {
      setArchivo(null);
      setError("El archivo supera el tamaño máximo permitido de 300 KB.");
      setMensaje("");
      return;
    }

    setArchivo(file);
    setMensaje("");
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!archivo) {
      setError("Por favor selecciona un archivo CSV.");
      return;
    }

    setCargando(true);

    const resultado = await postProcesarDeudores(archivo);

    setCargando(false);

    if (!resultado.ok) {
      setError("Error al procesar el archivo: " + resultado.mensaje);
    } else {
      setMensaje("Archivo procesado correctamente. Descarga iniciada.");
      setArchivo(null);
      setTimeout(() => {
        toggle(); // Cierra el modal después de un tiempo
      }, 1500);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setArchivo(null);
      setMensaje("");
      setError("");
      setCargando(false);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Subir CSV de Clientes</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="archivo">Selecciona un archivo CSV</Label>
            <Input
              type="file"
              name="archivo"
              id="archivo"
              accept=".csv"
              onChange={handleFileChange}
            />
          </FormGroup>

          {mensaje && <Alert color="success">{mensaje}</Alert>}
          {error && <Alert color="danger">{error}</Alert>}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={cargando}>
          {cargando ? <Spinner size="sm" /> : "Subir y Procesar"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={cargando}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalProcesarDeudoresCSV;
